import { wrapPageElement as wrap } from './src/woot-wrapper'

export const wrapPageElement = wrap